// extracted by mini-css-extract-plugin
export var card = "_sl-0";